import { Icon } from '@/src/tools/icon';
import { EyeOutlined } from '@ant-design/icons';
import React from 'react';
import { Button, SizeFittingTable } from 'src/components/Antd';
// import Search from '@/src/components/Antd/Search/Search';
// import { SearchOutlined } from '@ant-design/icons';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import TagGroup from 'src/components/TagGroup/TagGroup';
// import { get } from 'lodash';
// import ModalHoc from 'src/constrains/ModalHOC';
// import { getCollectionList } from '@/src/request/salesChannel/collection';
// import { useParams } from 'react-router-dom';
// import { generalSort } from 'src/tools/helper';
// import { mockData1 } from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection/Col';
import ProductSelection from 'src/constrains/ProductsSelection/ProductsSelection';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumTablePosition } from 'src/types/common/common';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const addParentUuid = (products) => {
  return products.map((i) => {
    const { children, uuid } = i;
    if (children) {
      const _children = children.map((child) => {
        return { parentUuid: uuid, ...child };
      });
      return { ...i, children: _children };
    }
    return i;
  });
};

// const removeParentUuid = (products) => {
//   products.map((i) => {
//     const { children } = i;
//     if (children) {
//       const _children = children.map((child) => {
//         delete child['parentUuid'];
//         return child;
//       });
//       return { ...i, children: _children };
//     }
//     return i;
//   });
// };

const ProductTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    value,
    onChange,
    id,
    tableId,
    salesChannelUuid,
    disabled,
    hideAlias,
    hideVisibility,
  } = props;
  const [products, setProducts] = React.useState(value || []);
  const isNoData = (products || []).length === 0;
  const [visible, setVisible] = React.useState(false);
  const processProduct = React.useMemo(() => {
    return addParentUuid(products || []);
  }, [products]);
  React.useEffect(() => {
    if (value !== products) {
      setProducts(value || []);
    }
  }, [value]);

  const handleOnCancel = () => {
    setVisible(false);
  };

  const handleOnChange = (products) => {
    if (onChange) {
      onChange(products);
    }
    // setProducts(products);
  };
  const handleOnDelete = (record, index) => {
    const { child, parentUuid, uuid } = record;
    if (!child) {
      const p = products.filter((i) => {
        return i.uuid !== uuid;
      });
      setProducts(p);
      handleOnChange(p);
    } else {
      const p = products.map((i) => {
        if (i.uuid === parentUuid) {
          const { children } = i;
          const _children = (children || []).filter((i) => i.uuid !== uuid);
          return { ...i, children: _children };
        } else {
          return i;
        }
      });
      setProducts(p);
      handleOnChange(p);
    }
  };
  const handleOnDeleteAll = () => {
    setProducts([]);
    handleOnChange([]);
  };
  const handleOnEdit = () => {
    setVisible(true);
  };
  const handleOnOk = (products) => {
    const _p = products;
    setProducts(_p);
    handleOnChange(_p);
    handleOnCancel();
  };
  return (
    <div className={css.productTableContainer} id={id}>
      {visible && (
        <ProductSelection
          // disabledProducts={
          //   // mockData
          //   disabledProducts
          // }
          //uniqueSku
          //  canSelectChildren
          selectedItems={products}
          onCancel={handleOnCancel}
          visible={visible}
          salesChannelUuid={salesChannelUuid}
          onOk={handleOnOk}
        />
      )}
      <SizeFittingTable
        id={tableId || 'SalesChannelProductTable' + id}
        dataSource={processProduct}
        pagination={false}
        columns={col(handleOnDelete, disabled, hideAlias, hideVisibility, {
          getI18n,
        })}
        rowKey={'uuid'}
        scroll={{ x: 'max-content', y: 600 }}
        expandable={{
          //indentSize: 16,
          expandIcon: ({ expanded, onExpand, record }) => {
            if (record.children) {
              return expanded ? (
                <Icon
                  onClick={(e) => onExpand(record, e)}
                  className={css.expandIcon}
                  type='iconleft'
                  style={{ transform: 'rotate(270deg)' }}
                />
              ) : (
                <Icon
                  type='iconleft'
                  onClick={(e) => onExpand(record, e)}
                  className={css.expandIcon}
                  style={{ transform: 'rotate(180deg)' }}
                />
              );
            }
            return null;
          },
        }}
      />
      <div className={css.btnsContainer}>
        <Button
          className={css.addBtn}
          type='primary'
          onClick={handleOnEdit}
          disabled={disabled}>
          {getI18n('general.selectProduct')}
        </Button>
        {!isNoData && (
          <Button
            className={`${css.deleteBtn} ${disabled ? css.disabled : ''}`}
            onClick={handleOnDeleteAll}
            disabled={disabled}>
            {getI18n('general.deleteall')}
          </Button>
        )}
      </div>
    </div>
  );
};
const col = (onDelete, disabled, hideAlias, hideVisibility, { getI18n }) => {
  return [
    {
      title: getI18n('general.productName'),
      dataIndex: 'name',
      default: true,
      sorter: (a, b) => {
        const name1 = a.name || '';
        const name2 = b.name || '';
        const n1 = name1.toLowerCase();
        const n2 = name2.toLowerCase();
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
        return 0;
      },

      className: css.expandRow,
      key: 'name',
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { thumbnailUrl, name } = record;
        return (
          <div className={css.productNameContainer}>
            {thumbnailUrl && (
              <img
                style={{
                  marginRight: 12,
                }}
                width={40}
                height={40}
                key={thumbnailUrl}
                src={thumbnailUrl}
                alt={thumbnailUrl}
              />
            )}
            <NoWrapContainer>
              <GlobalTooltip title={name || '-'}>
                <div className={css.text}>{name || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },

      minWidth: 220,
    },
    {
      title: getI18n('general.sKU'),
      dataIndex: 'sku',
      default: true,
      sorter: (a, b) => {
        const name1 = a.sku || '';
        const name2 = b.sku || '';
        const n1 = name1.toLowerCase();
        const n2 = name2.toLowerCase();
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
        return 0;
      },
      key: 'sku',

      minWidth: 100,
    },
    {
      title: getI18n('general.remarks'),
      dataIndex: 'remarks',
      default: true,
      key: 'remarks',
      minWidth: 100,
    },
    {
      title: getI18n('general.tags'),
      dataIndex: 'tags',
      default: true,
      align: 'center',
      key: 'tags',
      minWidth: 150,
      tags: true,
      tagsGenerator: (
        characterLength,
        width,
        marginPaddingWidth,
        containPaddingWidth,
        tags,
        record,
      ) => {
        return (
          <TagGroup
            characterLength={characterLength}
            containerWidth={width}
            marginPaddingWidth={marginPaddingWidth}
            containPaddingWidth={containPaddingWidth}
            tags={tags}
          />
        );
      },
    },
    {
      ...(!hideAlias && {
        title: getI18n('general.alias'),
        default: true,
        key: 'alias',
        minWidth: 72,
        childGenerate: (a, record) => {
          const { alias, child } = record;
          return (
            <span>{child ? '' : alias ? getI18n('general.alias') : '-'}</span>
          );
        },
      }),
    },
    {
      ...(!hideVisibility && {
        title: getI18n('general.visibility'),
        default: true,
        key: 'Visibility',
        align: 'center',
        width: 80,
        childGenerate: (a, record) => {
          const { visible } = record;
          return (
            <div className={css.icon}>
              {visible ? (
                <EyeOutlined className={css.eye} />
              ) : (
                <Icon type={'iconinvisible'} />
              )}
            </div>
          );
        },
      }),
    },
    {
      titleGenerate: () =>
        getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
      position: EnumTablePosition.mid,
      key: 'Actions',
      default: true,
      childGenerate: (url, record, index) => {
        return (
          <Actions
            disabled={disabled}
            onDelete={() => {
              if (onDelete && !disabled) {
                onDelete(record, index);
              }
            }}
          />
        );
      },
      width: 190,
    },
  ];
};
export default ProductTable;
